/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { TextField } from 'framework/ui/field';
import { EntityHeader } from 'framework/ui/layout';

const LeadEntityHeader = () => (
  <EntityHeader
    entityTitle={data =>
      `${data.getValueBySource('firstName')} ${data.getValueBySource('middleName') || ''} ${data.getValueBySource(
        'lastName',
      )}`
    }
    defaultAuthor={DEFAULT_ENTITY_AUTHOR}
  >
    <TextField source="title" label="" />
  </EntityHeader>
);

export default LeadEntityHeader;
